export const BALANCE = {
  fixedStep: 1 / 60,
  player: {
    maxAp: 10_000,
    maxEnergy: 100,
    maxStagger: 100,
    walkSpeed: 10,
    boostSpeed: 25,
    strafeSpeed: 0.9,
    acceleration: 42,
    groundDrag: 7,
    assaultDrainPerSecond: 23,
    verticalDrainPerSecond: 29,
    energyRechargePerSecond: 31,
    energyRechargeDelay: 0.72,
    quickBoostCost: 21,
    quickBoostSpeed: 34,
    quickBoostDuration: 0.18,
    quickBoostCooldown: 0.58,
    jumpImpulse: 11.5,
    gravity: 25,
    // Assault boost: the committed forward sprint. Fast enough to cross the
    // arena, expensive enough that it cannot be held indefinitely, and slow to
    // turn so that committing to it is an actual decision.
    assaultBoostSpeed: 48,
    assaultBoostDrainPerSecond: 41,
    assaultBoostTurnFactor: 0.32,
    // The shared blend divides by the target speed, so a higher ceiling would
    // otherwise mean a *slower* ramp — the assault drive would top out after
    // about three seconds and never read as a surge. Its own figure keeps the
    // time constant at ~0.4s.
    assaultBoostAcceleration: 120,
  },
  rifle: {
    damage: 285,
    impact: 8,
    cooldown: 0.14,
    range: 120,
  },
  missile: {
    damage: 380,
    impact: 13,
    cooldown: 3.1,
    speed: 27,
    turnRate: 5.2,
    life: 5,
    salvo: 4,
  },
  blade: {
    damage: 1_750,
    impact: 38,
    cooldown: 1.75,
    range: 11,
  },
  enemy: {
    projectileSpeed: 24,
    projectileDamage: 420,
    projectileImpact: 9,
  },
} as const

export const COLORS = {
  ice: 0x7fe7ff,
  iceBright: 0xc8f7ff,
  ember: 0xff6a24,
  hot: 0xffc05c,
  threat: 0xff3e2f,
  metal: 0x20282c,
  metalDark: 0x080d10,
  bone: 0xb8b7aa,
  dust: 0x7b3f2c,
  // Near-white flash for "this one counted": direct hits, stagger breaks,
  // pre-detonations. Kept a shade off pure white so it still tints toward the
  // palette's cold side when it blooms.
  flash: 0xf2fbff,
} as const

export const ARENA_RADIUS = 112

